import { safeDefine } from "../../registration/safe-define.js";
import { ControlsBackdropElement } from "../../ui/controls/backdrop.js";
//#region src/define/ui/controls-backdrop.ts
safeDefine(ControlsBackdropElement);
//#endregion
